// @flow
// $FlowFixMe
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { globalQueryClient } from "queries/queryClient";
import type { CustomerField } from "types/customerField";

import { QUERIES } from "@/enums/queries";

import { getCustomerFields } from "./services/loadCustomerFields";

export const useLoadCustomerFields = (
  options: any,
  // $FlowFixMe
): UseQueryResult<CustomerField[], Error> => {
  return useQuery({
    queryKey: [QUERIES.CUSTOMER_FIELDS.LIST],
    queryFn: ({ signal }) => {
      return getCustomerFields({ signal });
    },
    ...options,
  });
};

export const invalidateLoadCustomerFields = () => {
  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.CUSTOMER_FIELDS.LIST],
    exact: false,
  });
};
